var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScreenshots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33329 2.5H16.6666C17.1087 2.5 17.5326 2.67559 17.8451 2.98816C18.1577 3.30072 18.3333 3.72464 18.3333 4.16667V14.1667C18.3333 15.0833 17.5833 15.8333 16.6666 15.8333H13.3333V17.5H6.66663V15.8333H3.33329C2.89127 15.8333 2.46734 15.6577 2.15478 15.3452C1.84222 15.0326 1.66663 14.6087 1.66663 14.1667V4.16667C1.66663 3.24167 2.40829 2.5 3.33329 2.5ZM3.33329 14.1667H16.6666V4.16667H3.33329V14.1667ZM7.49996 6.25H5.41663V8.33333H4.16663V5H7.49996V6.25ZM14.5833 10H15.8333V13.3333H12.5V12.0833H14.5833V10Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshots);
export default __webpack_public_path__ + "static/media/screenshots.23ace1873deadcb26ba13d5661cb9df2.svg";
export { ForwardRef as ReactComponent };